import { Component, h, Prop } from '@stencil/core';
import { TranslationValues } from '../../../models/ITranslationValues';
import { Translations } from '../../../helpers/TranslationUtils';
import logoOntrace from '../../../assets/logo-ontrace.svg';

@Component({
  tag: 'uploading-data',
  shadow: false,
})
export class UploadingData {
  private translations: TranslationValues;

  @Prop() type: string;

  constructor() {}

  async componentWillLoad() {
    this.translations = await Translations.getValues();
  }

  render() {
    return (
      <div class="container flex center">
        <div class="px-2 w-100">
          <h1 class="text-center px-1 mb-2" innerHTML={this.type == 'id' ? this.translations.IdCaptureValues.Loading : this.translations.SelfieCaptureValues.Loading}></h1>
          <img class="w-100" src={'https://ekyc.blob.core.windows.net/$web/' + (this.type == 'id' ? 'uploading_id.gif' : 'uploading_selfie.gif')} />
          <div class="footer text-center">
            <img src={logoOntrace}></img>
          </div>
        </div>
      </div>
    );
  }
}
